/**
* @file component/Survey/Create/Brand/Edit/Height.tsx,
* @description 커버높이 조절,
* @author 백재인,
* @created 2025-07-03
*/

import { memo, ChangeEvent } from 'react'
import { useIntl } from "react-intl"
import { replaceNotNumber } from 'utils'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import { useStyles as useQuestionTopStyles } from './QuestionTop';
import { Props as ParentProps } from './Logo'

interface Props {
    coverHeight: ParentProps['coverHeight'];
    onChangeCoverHeight: ParentProps['onChangeCoverHeight'];
}

function CoverHeightComponent(props: Props) {
    const { coverHeight, onChangeCoverHeight } = props

    const { formatMessage: f } = useIntl()

    const questionTopClasses = useQuestionTopStyles();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        let val = replaceNotNumber(event.target.value);
        onChangeCoverHeight(Number(val));
    };

    return (
        <Box className={questionTopClasses.questionFixed}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={4} md={4}>
                    <Box className={questionTopClasses.helpBox} style={{ height: "100%" }}>
                        <Typography variant="body2">{f({id: 'component.Survey.Create.Brand.Edit.CoverHeight.title'})}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={8} md={8}>
                    <Box className={questionTopClasses.questionFixedCheckbox}>
                        <TextField 
                            variant="outlined"
                            type="number" 
                            margin="dense" 
                            value={coverHeight} 
                            fullWidth 
                            label={f({id: 'component.Survey.Create.Brand.Edit.CoverHeight.label'})}
                            inputProps={{  min: 50, max: 250, inputMode: 'numeric' }} onChange={handleChange} 
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )

}

export default memo(CoverHeightComponent)